export type FamilyMetadata = {
  description?: string;
  defaultSimulationSize?: number;
  resourcesKey?: string;
};

export type FamilyConfig = FamilyMetadata & {
  slug: string;
  label: string;
  matches: string[];
};

export const FAMILY_CONFIGS: FamilyConfig[] = [
  {
    slug: 'cfp',
    label: 'CFP',
    description: 'Simulados, materiais e vídeos focados na certificação CFP®.',
    matches: ['cfp', 'certified financial planner'],
  },
  {
    slug: 'cfg',
    label: 'CFG',
    description: 'Materiais para o exame de Certificação de Gestores (CFG).',
    matches: ['cfg'],
  },
  {
    slug: 'cga',
    label: 'CGA',
    description: 'Questões comentadas e vídeos para a certificação CGA.',
    matches: ['cga'],
  },
  {
    slug: 'ancord',
    label: 'ANCORD',
    description: 'Conteúdos voltados para o exame da ANCORD.',
    matches: ['ancord'],
  },
  {
    slug: 'cge',
    label: 'CGE',
    description: 'Estude com materiais selecionados para a certificação CGE.',
    matches: ['cge'],
  },
  {
    slug: 'cnpi',
    label: 'CNPI',
    description: 'Treino de questões para a certificação CNPI.',
    matches: ['cnpi'],
  },
  {
    slug: 'cnpi-cg',
    label: 'CNPI CG',
    description: 'Simulados direcionados para a trilha CNPI CG.',
    matches: ['cnpi cg', 'cnpi-cg'],
  },
  {
    slug: 'cnpi-ct',
    label: 'CNPI CT',
    description: 'Simulados direcionados para a trilha CNPI CT.',
    matches: ['cnpi ct', 'cnpi-ct'],
  },
  {
    slug: 'cfa-l1',
    label: 'CFA L1',
    description: 'Conteúdo voltado para o CFA Level I.',
    matches: ['cfa l1', 'cfa-l1', 'cfa level 1'],
  },
  {
    slug: 'cpa',
    label: 'CPA',
    description: 'Base de simulados para trilhas CPA.',
    matches: ['cpa'],
  },
  {
    slug: 'c-pro-i',
    label: 'C PRO I',
    description: 'Simulados e revisões para certificação C PRO I.',
    matches: ['c pro i', 'c-pro-i'],
  },
  {
    slug: 'c-pro-r',
    label: 'C PRO R',
    description: 'Simulados e revisões para certificação C PRO R.',
    matches: ['c pro r', 'c-pro-r'],
  },
  {
    slug: 'cfp-modulo-1',
    label: 'CFP - Módulo 1',
    description: 'Planejamento Financeiro: Princípios, Processos e Habilidades.',
    matches: ['cfp modulo 1', 'cfp-modulo-1', 'cfp modulo i', 'cfp-modulo-i'],
  },
  {
    slug: 'cfp-modulo-2',
    label: 'CFP - Módulo 2',
    description: 'Gestão Financeira.',
    matches: ['cfp modulo 2', 'cfp-modulo-2', 'cfp modulo ii', 'cfp-modulo-ii'],
  },
  {
    slug: 'cfp-modulo-3',
    label: 'CFP - Módulo 3',
    description: 'Planejamento de Investimentos & Gestão de Ativos.',
    matches: ['cfp modulo 3', 'cfp-modulo-3', 'cfp modulo iii', 'cfp-modulo-iii'],
  },
  {
    slug: 'cfp-modulo-4',
    label: 'CFP - Módulo 4',
    description: 'Planejamento de Aposentadoria.',
    matches: ['cfp modulo 4', 'cfp-modulo-4', 'cfp modulo iv', 'cfp-modulo-iv'],
  },
  {
    slug: 'cfp-modulo-5',
    label: 'CFP - Módulo 5',
    description: 'Planejamento de Seguros & Gestão de Risco.',
    matches: ['cfp modulo 5', 'cfp-modulo-5', 'cfp modulo v', 'cfp-modulo-v'],
  },
  {
    slug: 'cfp-modulo-6',
    label: 'CFP - Módulo 6',
    description: 'Planejamento Tributário.',
    matches: ['cfp modulo 6', 'cfp-modulo-6', 'cfp modulo vi', 'cfp-modulo-vi'],
  },
  {
    slug: 'cfp-modulo-7',
    label: 'CFP - Módulo 7',
    description: 'Planejamento Patrimonial & Sucessório.',
    matches: ['cfp modulo 7', 'cfp-modulo-7', 'cfp modulo vii', 'cfp-modulo-vii'],
  },
  {
    slug: 'cfp-modulo-8',
    label: 'CFP - Módulo 8',
    description: 'Psicologia no Planejamento Financeiro.',
    matches: ['cfp modulo 8', 'cfp-modulo-8', 'cfp modulo viii', 'cfp-modulo-viii'],
  },
];

export function getFamilyMetadata(slug?: string | null): FamilyMetadata | undefined {
  if (!slug) {
    return undefined;
  }
  const normalized = slug.toLowerCase();
  return FAMILY_CONFIGS.find(item => item.slug === normalized);
}

export function normalizeFamilyToken(value?: string | null) {
  if (!value) return '';
  return value.toLowerCase().replace(/[^a-z0-9]/g, '');
}
